<template>
<div class="z-main">
	<header class="z-header">
		<div><router-link to="/index"><img src="../../assets/sysbars/left.png" /></router-link></div>
		<div>客服</div>
		<div>&nbsp;</div>
	</header>
	<div class="z-body z-body-bottom0 z-body-noscroll">
		<iframe :src="src" frameborder="0"></iframe>
	</div>
</div>
</template>

<script>
export default {
	name: 'kf',
	data() {
		return {
			timestamp:Date.parse(new Date()),
			src:''
		}
	},
	created() {
		this.get('api/index/kfurl',{}).then((rs)=>{
			this.src = rs.data
		})
	},
	methods: {

	},
	destroyed:function () {
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>


// WEBPACK FOOTER //
// src/pages/index/kf.vue